import React, { FormEvent, useState, useEffect } from "react";

import axios from "axios";
import moment from "moment";
import "moment/locale/ru";

import Aside from "../../components/Aside/Aside";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import {TailSpin} from "react-loader-spinner";
import { Profile } from "../../types";
import { Navigate } from "react-router-dom";

export interface Traffic {
  TclassName: string;
  DiscountDate: number;
  AccID: number;
  Bytes: number;
  BaseCost: number;
  Charge: number;
  ChargeWithTax: number;
}

interface TraffiProps {}

moment().locale("ru");

const TrafficPage: React.FC<TraffiProps> = () => {
  const [profile, setProfile] = useState<Profile>();

  const [inc, setInc] = useState<Traffic[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [isModalOpen, setModalState] = React.useState(false);

  const toggleModal = () => setModalState(!isModalOpen);

  const onChangeSelectedDateStart = (date: any) => {
    setStartDate((date.getTime() / 1000).toFixed(0));
  };

  useEffect(() => {
    try {
      axios.get("v1/profile/info").then((res) => setProfile(res.data));
    } catch (err) {
      console.error(err);
    }
  }, []);

  if (profile?.tariffName === "Стартовый Ямал") return <Navigate to="/inet/activate" />;

  const getTraffic = async (event: FormEvent) => {
    event.preventDefault();

    setModalState(!isModalOpen)
    setIsLoaded(true);


    const startTime = new Date(new Date().setDate(new Date().getDate() - 7));
    const unixStartTime = (startTime.getTime() / 1000).toFixed(0);

    const endTime = new Date();
    const unixEndTime = (endTime.getTime() / 1000).toFixed(0);

    try {
      const { data } = await axios.post("v1/traffic/user/upstream", {
        username: `${profile?.username}`,
        start: `${!startDate ? unixStartTime : startDate}`,
        end: unixEndTime,
      });

      setIsLoaded(false);

      setIsOpen(true);
      setInc(data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside />
      <div style={{ width: "100%" }}>
        <div data-v-dde546dc="" className="el-main">
          <div
            data-v-1a853a98=""
            data-v-dde546dc=""
            className="reports-traffic "
          >
            <h1 data-v-1a853a98="">Графический отчет загрузки канала</h1>
            <div
              data-v-1a853a98=""
              className="flex justify-between align-center"
            >
              <div className="flex">
                <p style={{ fontSize: 20 }}>Сгенерировать график</p>
              </div>
              <div className="flex flex-column">
                <input
                  placeholder="Дата начала"
                  style={{ padding: "10px", fontSize: "16px" }}
                  value={endDate}
                  onClick={toggleModal}
                />
                {isModalOpen ? (
                  <Calendar
                    className="calendar"
                    onChange={onChangeSelectedDateStart}
                    //value={value}
                    locale="ru-RU"
                    maxDetail="month"
                    minDate={
                      new Date(new Date().setDate(new Date().getDate() - 7))
                    }
                    maxDate={
                      new Date(new Date().setDate(new Date().getDate() - 1))
                    }
                  />
                ) : null}
              </div>
              <div className="flex">
                <button
                  data-v-1a853a98=""
                  type="button"
                  className="el-button el-button--primary el-button--small"
                  onClick={getTraffic}
                >
                  <span>
                    <small data-v-1a853a98="">Показать</small>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoaded ? (
          <div data-v-dde546dc="" className="el-main">
            <div
              data-v-dde546dc=""
              className="dashboard justify-center align-center flex"
            >
              <TailSpin color="#d6f1dc" height={100} width={100} />
            </div>
          </div>
        ) : isOpen ? (
          <>
            {inc == null ? (
              <h1 className="flex justify-center center">
                Данные по трафику отсутствуют.
              </h1>
            ) : (
              <>
                <h1
                  style={{ textAlign: "center", fontWeight: 600, fontSize: 18 }}
                >
                  Входящий (Кбит/с)
                </h1>

                <ResponsiveContainer width="100%" height={300}>
                  <LineChart
                    width={500}
                    height={300}
                    data={inc}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="time"
                      tickFormatter={formatXAxis}
                      tick={{ fontSize: 12 }}
                    />
                    <YAxis
                      domain={[0, "auto"]}
                      interval={0}
                      tickCount={20}
                      tick={{ fontSize: 10 }}
                    />

                    <Line
                      isAnimationActive={false}
                      dot={false}
                      connectNulls
                      type="monotone"
                      dataKey="downstream"
                      stroke="#4e9bdf"
                      fill="#4e9bdf"
                    />
                  </LineChart>
                </ResponsiveContainer>
                <h1
                  style={{ textAlign: "center", fontWeight: 600, fontSize: 18 }}
                >
                  Исходящий (Кбит/с)
                </h1>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart
                    width={500}
                    height={300}
                    data={inc}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="time"
                      tickFormatter={formatXAxis}
                      tick={{ fontSize: 12 }}
                    />
                    <YAxis
                      domain={[0, "auto"]}
                      interval={0}
                      tickCount={20}
                      tick={{ fontSize: 10 }}
                    />

                    <Line
                      isAnimationActive={false}
                      dot={false}
                      type="monotone"
                      dataKey="upstream"
                      stroke="#e15656"
                      fill="#e15656"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

function formatXAxis(tickItem: number) {
  return moment.unix(tickItem).format("D MM H:mm:ss");
}

export default TrafficPage;
